import angular from 'angular';

import { accessLevels } from '@angular/constants';

import placeholderTemplateUrl from './placeholder.html';

const announcementsModule = angular.module('sling.dashboard.announcements', []);

announcementsModule.config(($stateProvider) => {
  $stateProvider.state('dashboard.announcements', {
    url: '/announcements',
    templateUrl: placeholderTemplateUrl,
    data: {
      title: 'Announcements',
      access: accessLevels.user,
    },
  });
});

export default announcementsModule.name;
